var base = window.base;
var base;
(base = window.Aedu).Notifications || (base.Notifications = {});
window.base = base;